module.exports = __webpack_public_path__ + "static/media/investpic1@2x.c17d6034.png";